import { ENTERPRISE_CONTACT_PATH } from '../../packs/constants/enterpriseContact.constants'

/** Path-only check for root-mounted org drawer (testable without `react-native`). */
export function isAccountAdminWebDrawerHostPath(pathname: string): boolean {
  const p = pathname === '' ? '/' : pathname
  if (p.startsWith('/app/')) {
    return false
  }
  return (
    p === '/' ||
    p.startsWith('/account-admin') ||
    p === '/organizations' ||
    p.startsWith('/organizations/') ||
    p === '/packs' ||
    p.startsWith('/packs/') ||
    p === ENTERPRISE_CONTACT_PATH ||
    p.startsWith(`${ENTERPRISE_CONTACT_PATH}/`) ||
    p === '/contact' ||
    p.startsWith('/contact/')
  )
}
